document.addEventListener("DOMContentLoaded", () => {
  const hiddenSellingPlanElm = document.getElementById("mikawaya-hidden-selling-plan-id");
//   console.log("hiddenSellingPlanElm:", hiddenSellingPlanElm);

  const form = document.querySelector('form[id^="product-form-"]');
//   console.log("form:", form); 


  if (hiddenSellingPlanElm && form) {
    const formId = form.getAttribute("id")
    hiddenSellingPlanElm.setAttribute("form", formId);
  }
});